import { render, staticRenderFns } from "./LegalDialog.vue?vue&type=template&id=7eb596d4"
import script from "./LegalDialog.vue?vue&type=script&lang=js"
export * from "./LegalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports